import ImageAudio from 'app/components/tests/media/ImageAudio';
import * as categoryConst from 'app/constants/categories';
import * as testConst from 'app/constants/tests';
import { forwardRef, ForwardedRef } from 'react';
import { useAudioManager } from './AudioManager';
import { AppStoreState } from 'app/redux/store';
import { useSelector } from 'react-redux';
import { Group } from 'types/test';
import env from '.env.json';

interface AudioPlayerProps {
  group: Group,
}

const AudioPlayer = (props: AudioPlayerProps, ref: ForwardedRef<HTMLAudioElement>) => {
  const { test, process } = useSelector((state: AppStoreState) => state.test);
  const { registerAndPlay } = useAudioManager();

  const partId = Number(props.group?.part_id);
  const isToeicListening = [testConst.TOEIC_P2, testConst.TOEIC_P3, testConst.TOEIC_P4].includes(partId);
  const IELT_LISTEN = test.category_id == categoryConst.IELT_LISTEN;

  const handlePlay = () => {
    if (ref && 'current' in ref && ref.current) {
      registerAndPlay(ref.current);
    }
  };

  return (
    <div className="audio-player">
      <div className="mt-3 form-group">
        {test.audio && (
          <div className={`group-image-audio ${IELT_LISTEN ? 'd-none' : ''}`}>
            <div className="form-group audio-box">
              <audio
                controlsList="nodownload"
                ref={ref}
                controls
                onPlay={handlePlay}
                src={`${env.URL_APP_FILE || env.URL_API}/storage/${test.audio}`}
              />
            </div>
          </div>
        )}
        <ImageAudio
          data={props.group}
          hide={isToeicListening && process !== 'complete'}
        />
      </div>
    </div>
  );
};

export default forwardRef<HTMLAudioElement, AudioPlayerProps>(AudioPlayer);
